enum TimelineStatus {
    TRACKING   = 'TRACKING',
    SCRUBBING  = 'SCRUBBING'
}

export default TimelineStatus;